import reactUniversalComponent from '@nerdwallet/coin/universal';
export default reactUniversalComponent;